import React, { useRef } from 'react';
import { connect } from 'react-redux';
import { logout } from '../../actions/auth';

const LogoutModal = ({ logout }) => {
  const closeRef = useRef(null);

  return (
    <div className="modal fade" id="logoutModal">
      <div className="modal-dialog modal-dialog-centered modal-sm" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Time to Go?</h5>
            <button type="button" data-dismiss="modal" aria-label="close" className="close"
              ref={closeRef}
            >
              <i className="fal fa-fw fa-times"></i>
            </button>
          </div>

          <div className="modal-body">
            <div className="modal-text">When you are ready to end your current session, click "Logout" below.</div>
          </div>

          <div className="modal-footer justify-content-center">
            <button className="btn-action-secondary mr-4" data-dismiss="modal" type="button">
              Cancel
            </button>

            <a href="#!" className="btn-action-primary deleteButton"
              onClick={(e) => { e.preventDefault(); logout(); }}
            >
              Confirm
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default connect(null, { logout })(LogoutModal);